/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  // Newsletter purchase gate — block ATC for newsletter-only products without subscriber tag
  (function() {
    var POPUP_VISIBLE_CLASS = 'newsletter-gate-popup-visible';
    var popup = null;
    var productTagsByHandle = {};
    var isValidatingCart = false;
    var validationQueued = false;

    function getConfig() {
      return window.NewsletterGateConfig || {};
    }

    function getPopup() {
      if (!popup) {
        popup = document.querySelector('[data-newsletter-gate-popup]');
      }
      return popup;
    }

    function openPopup() {
      var el = getPopup();
      if (!el) return;
      el.hidden = false;
      el.setAttribute('aria-hidden', 'false');
      document.body.classList.add(POPUP_VISIBLE_CLASS);
    }

    function closePopup() {
      var el = getPopup();
      if (!el) return;
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove(POPUP_VISIBLE_CLASS);
    }

    function isGatedForm(form) {
      if (!form || form.getAttribute('data-newsletter-only') !== 'true') return false;
      var config = getConfig();
      return config.customerCanPurchase !== true;
    }

    function isCartMutationRequest(url) {
      return /\/cart\/(add|update|change|clear)\.js(\?|$)/.test(url || '');
    }

    function queueCartValidation() {
      if (isValidatingCart) {
        validationQueued = true;
        return;
      }

      validateCartItems().catch(function() {});
    }

    function getFetchUrl(input) {
      if (typeof input === 'string') return input;
      if (input && typeof input.url === 'string') return input.url;
      return '';
    }

    function fetchJson(url, options) {
      return window.fetch(url, options).then(function(response) {
        if (!response.ok) {
          throw new Error('Request failed: ' + response.status);
        }
        return response.json();
      });
    }

    function getProductTagsByHandle(handle) {
      if (!handle) return Promise.resolve([]);
      if (productTagsByHandle[handle]) return Promise.resolve(productTagsByHandle[handle]);

      return fetchJson('/products/' + encodeURIComponent(handle) + '.js').then(function(productJson) {
        var tags = Array.isArray(productJson && productJson.tags) ? productJson.tags : [];
        productTagsByHandle[handle] = tags;
        return tags;
      }).catch(function() {
        productTagsByHandle[handle] = [];
        return [];
      });
    }

    function removeBlockedCartLines(linesToRemove) {
      if (!linesToRemove.length) return Promise.resolve();

      var updates = {};
      linesToRemove.forEach(function(item) {
        updates[item.key] = 0;
      });

      return fetchJson('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function() {
        openPopup();
        if (window.location.pathname === '/cart') {
          window.location.reload();
        }
      });
    }

    function validateCartItems() {
      var config = getConfig();
      if (config.customerCanPurchase === true) return Promise.resolve();

      var productTag = config.productTag || 'produkt-newsletter';
      isValidatingCart = true;

      return fetchJson('/cart.js').then(function(cart) {
        var items = Array.isArray(cart && cart.items) ? cart.items : [];
        return Promise.all(items.map(function(item) {
          return getProductTagsByHandle(item.handle).then(function(tags) {
            return { item: item, tags: tags };
          });
        }));
      }).then(function(entries) {
        var blocked = entries.filter(function(entry) {
          return entry.tags.indexOf(productTag) !== -1;
        }).map(function(entry) {
          return entry.item;
        });

        return removeBlockedCartLines(blocked);
      }).finally(function() {
        isValidatingCart = false;
        if (validationQueued) {
          validationQueued = false;
          queueCartValidation();
        }
      });
    }

    function handleGateTrigger(event) {
      var trigger = event.target.closest('[data-newsletter-gate-trigger]');
      if (!trigger) return;

      var form = trigger.closest('form[data-product-form], form[data-quickbuy-form], form[data-product-form-upsell]');
      if (form && !isGatedForm(form)) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      openPopup();
    }

    function handleFormSubmit(event) {
      var form = event.target;
      if (!form.matches('form[data-product-form], form[data-quickbuy-form], form[data-product-form-upsell]')) return;
      if (!isGatedForm(form)) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      openPopup();
    }

    document.addEventListener('click', handleGateTrigger, true);
    document.addEventListener('submit', handleFormSubmit, true);

    if (window.fetch) {
      var nativeFetch = window.fetch.bind(window);
      window.fetch = function(input, init) {
        var url = getFetchUrl(input);
        return nativeFetch(input, init).then(function(response) {
          if (isCartMutationRequest(url)) {
            setTimeout(queueCartValidation, 0);
          }
          return response;
        });
      };
    }

    setTimeout(queueCartValidation, 0);

    document.addEventListener('click', function(event) {
      if (event.target.closest('[data-newsletter-gate-close]')) {
        closePopup();
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        closePopup();
      }
    });
  })();

  // Show Miami bag upsell for visitors of the subscriber collection
  (function() {
    var SUBSCRIBER_KEY = 'me_subscriber';

    // Set sessionStorage flag when on subscriber collection pages (clears on browser close)
    if (window.location.pathname.includes('/collections/subskrybenci')) {
      sessionStorage.setItem(SUBSCRIBER_KEY, '1');
    }

    // On every page: if flag exists, sync cart attribute so Liquid can read it
    if (sessionStorage.getItem(SUBSCRIBER_KEY)) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { me_subscriber: 'true' } })
      }).catch(function() {});
    }

    // Tag individual cart items as backup detection method
    if (window.location.pathname.includes('/collections/subskrybenci')) {
      document.addEventListener('DOMContentLoaded', function() {
        document.querySelectorAll('[data-product-form]').forEach(function(form) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[_source_collection]';
          input.value = 'subskrybenci';
          form.appendChild(input);
        });
      });
    }
  })();

  document.addEventListener('DOMContentLoaded', function() {
    const isDesktop = window.matchMedia('(min-width: 990px)').matches;
    if (!isDesktop) return;

    const images = document.querySelectorAll(
      '.product__media img, .product__image-wrap img, .product__slide img, .product__media-item img'
    );

    images.forEach(function(img) {
      const container =
        img.closest('.product__media, .product__media-item, .product__slide, .product__image-wrap') ||
        img.parentElement;

      if (!container) return;

      container.style.overflow = 'hidden';
      img.style.transition = 'transform 0.2s ease';

      container.addEventListener('mousemove', function(e) {
        const rect = container.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;

        img.style.transformOrigin = x + '% ' + y + '%';
        img.style.transform = 'scale(1.10)';
      });

      container.addEventListener('mouseleave', function() {
        img.style.transform = 'scale(1)';
        img.style.transformOrigin = 'center center';
      });
    });
  }); // ^^ Keep your scripts inside this IIFE function call to
      // avoid leaking your variables into the global scope.
  // Mother Earth — poprawka ARIA dla karuzeli produktów i GLO
  (function() {
    if (window.motherEarthCarouselA11yInstalled) return;

    function init() {
      var selector = '.product-grid-item.carousel__item';
      var sliders = new Set();

      document.querySelectorAll(selector).forEach(function(slide) {
        var slider = slide.closest('[data-slider-id]');
        if (slider) sliders.add(slider);
      });

      if (!sliders.size) return;

      window.motherEarthCarouselA11yInstalled = true;

      sliders.forEach(function(slider) {
        function sync() {
          slider.querySelectorAll(selector).forEach(function(slide) {
            var hidden = slide.getAttribute('aria-hidden') === 'true';

            slide.querySelectorAll(
  'a.gsw-prg-item--link, input[type="radio"], button.wk-button'
).forEach(function(el) {
              if (hidden) {
                el.setAttribute('tabindex', '-1');
              } else {
                el.removeAttribute('tabindex');
              }
            });
          });
        }

        sync();

        var observer = new MutationObserver(sync);

        observer.observe(slider, {
          subtree: true,
          attributes: true,
          attributeFilter: ['aria-hidden'],
          childList: true
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
})();
